import Moment from 'moment';
import { createSelector } from 'reselect';

const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  startDate: null,
  filters: {},
  members: [],
  suggestions: [],
};

const getErrors = state => state.errors;
const getLoading = state => state.loading;
const getStartDate = state => state.startDate;
const getEndDate = state => state.endDate;
const getDates = createSelector(
  getStartDate,
  getEndDate,
  (startDate, endDate) => Moment.range(Moment(startDate), Moment(endDate)).toArray('days', true),
);

const schedule = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LOGIN_USER_SUCCESS':
    case 'USER_GET_SESSION_SUCCESS':
      return {
        ...state,
        filters: payload.preferences.saved_schedule_filters || state.filters,
      };
    case 'SCHEDULE_UPDATE_FILTERS':
      return {
        ...state,
        filters: payload,
      };
    case 'SCHEDULE_REQUEST':
      return {
        ...state,
        startDate: payload.startDate,
        endDate: payload.endDate,
        loading: true,
      };
    case 'SUGGESTION_REQUEST':
      return {
        ...state,
        phaseId: payload.phaseId || 'N/A',
        startDate: payload.startDate || 'N/A',
        loading: true,
      };
    case 'SCHEDULE_SUCCESS':
      return {
        ...state,
        ...payload,
        loading: false,
        loaded: true,
        errors: {},
      };
    case 'SUGGESTION_SUCCESS':
      return {
        ...state,
        ...payload,
        members: [],
        loading: false,
        loaded: true,
        errors: {},
      };
    case 'SCHEDULE_FAILURE':
      return {
        ...state,
        errors: payload.errors || {},
        loading: false,
      };
    default:
      return state;
  }
};

export default schedule;
export { getErrors, getLoading, getDates };



// WEBPACK FOOTER //
// ./client/app/reducers/schedule.js